"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
} from "@relume_io/relume-ui";
import { RxPlus } from "react-icons/rx";

export function Faq6() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container grid grid-cols-1 gap-y-12 md:grid-cols-2 md:gap-x-12 lg:grid-cols-[.75fr,1fr] lg:gap-x-20">
        <h2 className="rb-5 mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
          FAQs
        </h2>
        <p className="md:text-md">
          Learn how you can support our mission and make a difference for dogs
          in need.
        </p>
        <div className="mt-6 md:mt-8">
          <Button title="Contact" variant="secondary">
            <a target="_blank" href="https://www.instagram.com/kiva_care_foundation/">
            Contact
            </a>
          </Button>
        </div>
        <Accordion
          type="multiple"
          className="grid items-start justify-stretch gap-4"
        >
          <AccordionItem
            value="item-0"
            className="border border-border-primary px-5 md:px-6"
          >
            <AccordionTrigger
              icon={
                <RxPlus className="size-7 shrink-0 text-text-primary transition-transform duration-300 md:size-8" />
              }
              className="md:py-5 md:text-md [&[data-state=open]>svg]:rotate-45"
            >
              How can I help?
            </AccordionTrigger>
            <AccordionContent className="md:pb-6">
              You can help by donating, volunteering your time, or adopting a
              dog. Every contribution counts and makes a significant impact.
              Join us in our mission to rescue and care for dogs in need.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            value="item-1"
            className="border border-border-primary px-5 md:px-6"
          >
            <AccordionTrigger
              icon={
                <RxPlus className="size-7 shrink-0 text-text-primary transition-transform duration-300 md:size-8" />
              }
              className="md:py-5 md:text-md [&[data-state=open]>svg]:rotate-45"
            >
              Where do donations go?
            </AccordionTrigger>
            <AccordionContent className="md:pb-6">
              Donations go directly towards veterinary care, food, and shelter
              for rescued dogs. We ensure transparency in our spending and
              regularly update our supporters on how funds are utilized. Your
              generosity helps us save more lives.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            value="item-2"
            className="border border-border-primary px-5 md:px-6"
          >
            <AccordionTrigger
              icon={
                <RxPlus className="size-7 shrink-0 text-text-primary transition-transform duration-300 md:size-8" />
              }
              className="md:py-5 md:text-md [&[data-state=open]>svg]:rotate-45"
            >
              Can I volunteer remotely?
            </AccordionTrigger>
            <AccordionContent className="md:pb-6">
              Yes, we offer remote volunteer opportunities such as fundraising
              and social media support. You can contribute your skills from
              anywhere. Reach out to us to learn more about how you can get
              involved.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            value="item-3"
            className="border border-border-primary px-5 md:px-6"
          >
            <AccordionTrigger
              icon={
                <RxPlus className="size-7 shrink-0 text-text-primary transition-transform duration-300 md:size-8" />
              }
              className="md:py-5 md:text-md [&[data-state=open]>svg]:rotate-45"
            >
              What is your mission?
            </AccordionTrigger>
            <AccordionContent className="md:pb-6">
              Our mission is to rescue, rehabilitate, and rehome dogs in need.
              We strive to provide a safe haven for abandoned and abused
              animals. Together, we can create a world where every dog is loved
              and cared for.
            </AccordionContent>
          </AccordionItem>
          <AccordionItem
            value="item-4"
            className="border border-border-primary px-5 md:px-6"
          >
            <AccordionTrigger
              icon={
                <RxPlus className="size-7 shrink-0 text-text-primary transition-transform duration-300 md:size-8" />
              }
              className="md:py-5 md:text-md [&[data-state=open]>svg]:rotate-45"
            >
              How do I adopt?
            </AccordionTrigger>
            <AccordionContent className="md:pb-6">
              To adopt a dog, fill out our adoption application on our website.
              Once approved, you can meet our dogs and find the perfect match.
              We guide you through the adoption process to ensure a smooth
              transition.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
}
